export const resolveSyntheticResultsEditorAvailability = (input: {
    declaredEnvironment?: string;
    mode?: string;
    hostname?: string;
}): boolean => {
    const declared = String(input.declaredEnvironment ?? '').toLowerCase();
    if (declared === 'production' || declared === 'prod') return false;
    if (['staging', 'development', 'dev', 'local', 'test'].includes(declared)) return true;
    const host = String(input.hostname ?? '').toLowerCase();
    if (host.includes('staging') || host === 'localhost' || host === '127.0.0.1') return true;
    return input.mode === 'development' || input.mode === 'test';
};

export const isSyntheticResultsEditorAvailable = (): boolean => {
    return resolveSyntheticResultsEditorAvailability({
        declaredEnvironment: import.meta.env?.VITE_NODE_ENV,
        mode: import.meta.env?.MODE,
        hostname: typeof window === 'undefined' ? '' : window.location.hostname,
    });
};
